import { render, staticRenderFns } from "./ManageStu.vue?vue&type=template&id=391f3dda"
import script from "./ManageStu.vue?vue&type=script&lang=js"
export * from "./ManageStu.vue?vue&type=script&lang=js"
import style0 from "./ManageStu.vue?vue&type=style&index=0&id=391f3dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports